// extracted by mini-css-extract-plugin
module.exports = {"header":"EmptyStates-module__header___2DEFs","text":"EmptyStates-module__text___2KuMk"};